import JSX from "../../helpers/react.js";

export function SendActionBtns(){
    return (
        <div>
            <button className="main-button send-comment col bordered">Отправить</button>
        </div>
    );
}
